import React from 'react'
import styled, { keyframes } from 'styled-components'

interface ITransitionState {
	isVisible: boolean
	viewState: string
}

interface IAnimation {
	$animation: any
	$duration: string
}

const entering = keyframes`
  0% {
    transform: translate(100%, 0);
  }
  100% {
     transform: translate(0, 0);
  }
`

const exiting = keyframes`
  0% {
    transform: translate(0, 0);
  }
  100% {
     transform: translate(-100%, 0);
  }
`

const Wrapper = styled.div<IAnimation>`
	width: 100%;
	height: 100%;
	animation: ${(props) => {
			return props.$animation
		}}
		${(props) => {
			return props.$duration
		}}
		ease-in-out;
	animation-fill-mode: forwards;
	position: absolute;
	top: 0;
	left: 0;
	overflow: hidden;
`

const withTransition = (Component: any) => {
	//TODO: find a way to avoid using any here
	// return class Transition extends React.PureComponent<ITransitionProps, ITransitionState> {
	return class Transition extends React.PureComponent<any, ITransitionState> {
		private timeoutId: number

		static defaultProps = {
			transitionDuration: 0.5,
		}

		constructor(props: any) {
			super(props)
			this.timeoutId = 0
		}

		state = {
			isVisible: false,
			viewState: '',
		}

		componentDidMount() {
			if (this.props.shouldRender) {
				this.setState({
					isVisible: true,
					viewState: 'entering',
				})
			}
		}

		componentDidUpdate(prevProps: any) {
			if (!prevProps.shouldRender && this.props.shouldRender) {
				window.clearTimeout(this.timeoutId)
				this.setState({
					isVisible: true,
					viewState: 'entering',
				})
			} else if (prevProps.shouldRender && !this.props.shouldRender && this.state.viewState !== 'exiting') {
				this.setState({
					viewState: 'exiting',
				})
				this.timeoutId = window.setTimeout(() => {
					this.setState({
						isVisible: false,
					})
				}, 600)
			}
		}

		getAnimation(viewState: string) {
			switch (viewState) {
				case 'entering':
					return entering
				case 'exiting':
					return exiting
				default:
					return ''
			}
		}

		getDuration(viewState: string) {
			const duration = this.props.transitionDuration + 's'
			switch (viewState) {
				case 'entering':
					return duration
				case 'exiting':
					return duration
				default:
					return ''
			}
		}

		render() {
			//TODO: fix type to remove transition props
			/*let props = Object.keys(this.props)
			.filter(key=> key !== 'view' && key !== 'shouldRender')
			.reduce((acc: any, value: string)=>{ acc[value] = this.props[value]; return acc}, {})
			console.log(props)*/
			if (this.state.isVisible) {
				return (
					<Wrapper
						$animation={this.getAnimation(this.state.viewState)}
						$duration={this.getDuration(this.state.viewState)}
					>
						<Component {...this.props} />
					</Wrapper>
				)
			} else {
				return null
			}
		}

		componentWillUnmount() {
			window.clearTimeout(this.timeoutId)
		}
	}
}

export default withTransition
